export default function reducer(state={
    web3Instance:null,
    ipfsInstance:null,
    theWallContract:null,
    theWallInstance:null,
    ethAccount:null,
    pending:false,
    error:false,
  }, action) {

    switch (action.type) {
      case "INIT_WEB3_SUCCESS": {
        if(state.web3Instance === null && state.ipfsInstance === null) {            
            return {...state, 
                web3Instance: action.payload.web3Instance, 
                ipfsInstance: action.payload.ipfsInstance, 
                theWallContract: action.payload.theWallContract, 
                theWallInstance: action.payload.theWallInstance, 
                ethAccount:action.payload.ethAccount, 
                pending:false, 
                error:false}
        }
        else {
          return state
        }
      }
      case "INIT_WEB3_ERROR": {
        console.log("INIT_WEB3_ERROR: " + action.payload);

        return {...state, 
            pending:false, 
            error:true}
      }
      case "INIT_WEB3_PENDING": {
        return {...state, 
            pending:true, 
            error:false}
      }
      default: {
        return state
      }
    }
}



// WEBPACK FOOTER //
// ./src/reducers/web3Reducer.js